export const HD = 'HD'
export const UHD = 'UHD'
